import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader.js'

const ktx2Loader = new KTX2Loader()
ktx2Loader.setTranscoderPath(`${import.meta.env.VITE_BASE_ASSETS_URL}static/lib/basis/`) //basis_transcoder.js

/** KTX2 파일 로더 반환 함수 */
export function getKtx2Loader(renderer: any) {
  renderer && ktx2Loader.detectSupport(renderer)
  return ktx2Loader
}

/** 터치 디바이스 여부를 반환하는 함수 */
export function isTouchDevice(): boolean {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}

/** 모바일 디바이스 여부를 판별하는 객체. Android, iOS, any 메서드 포함 */
export const isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i)
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i)
  },
  any: function () {
    return isMobile.Android() || isMobile.iOS()
  },
}

/** 브라우저가 IOS 기기인지 판단. **/
export function isIOS() {
  return navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)
}

/** 두 지점 사이의 거리가 주어진 반경 내에 있는지 판별하는 함수 */
export function checkInsideOne(lat1: number, lng1: number, lat2: number, lng2: number, radius: number) {
  function deg2rad(deg: number) {
    return deg * (Math.PI / 180)
  }

  const R = 6371 // 지구의 반지름 (km 단위)
  const dLat = deg2rad(lat2 - lat1) // deg2rad below
  const dLon = deg2rad(lng2 - lng1)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c // Distance in km

  const distance = Math.round(d * 1000) // m 단위로 변환

  if (radius > distance) {
    return { isInside: true, distance } // 내부에 있음
  } else {
    return { isInside: false, distance } // 밖에 있음
  }
}

/** 지정된 길이의 랜덤 ID 문자열 생성 함수 */
export function randomId(length = 6) {
  return Math.random()
    .toString(36)
    .substring(2, length + 2)
}

/** 한글 문자열의 마지막 글자가 받침으로 끝나는지 여부를 반환하는 함수 */
export function isEndWithConsonant(korStr: string) {
  const finalChrCode = korStr.charCodeAt(korStr.length - 1)
  // 0 = 받침 없음, 그 외 = 받침 있음
  const finalConsonantCode = (finalChrCode - 44032) % 28
  return finalConsonantCode !== 0
}

/** 문자열의 바이트 크기를 반환하는 함수 */
export function checkStringSize(str: string) {
  return new Blob([str]).size
}

/** 숫자에 콤마를 추가하여 문자열로 반환하는 함수 */
export function numWithComma(num: number) {
  const num_parts = num.toString().split('.')
  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return num_parts.join('.')
}

/** 숫자가 10 미만일 경우 앞에 '0'을 붙여 반환하는 함수 */
export const fillZero = (num: number) => {
  return num < 10 ? '0' + num : num
}

/** 두 점사이의 각도를 반환하는 함수 **/
export function CalculateAngle(x1: number, y1: number, x2: number, y2: number) {
  const rad = Math.atan2(y2 - y1, x2 - x1)
  return (rad * 180) / Math.PI
}

export function CalculateDistance(lat1: number, lng1: number, lat2: number, lng2: number) {
  function deg2rad(deg: number) {
    return deg * (Math.PI / 180)
  }

  const R = 6371 // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1) // deg2rad below
  const dLon = deg2rad(lng2 - lng1)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c // Distance in km

  const distance = Math.round(d * 1000)
  return distance

  // if (radius > distance) {
  //   return { isInside: true, distance } // 내부에 있음
  // } else {
  //   return { isInside: false, distance } // 밖에 있음
  // }
}

/** 값을 입력받아서 원하는 범위의 값으로 변경해서 보여줌 **/
export function normalizeValue(x: number, xMin: number, xMax: number, a: number, b: number) {
  // 클램핑: 최소값 또는 최대값으로 제한
  if (x < xMin || x > xMax) {
    return x < xMin ? a : b
  }
  const y = a + ((x - xMin) * (b - a)) / (xMax - xMin)
  return y
}
